"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCrustAuthToken = void 0;
const util_1 = require("@polkadot/util");
const keyring_1 = require("@polkadot/keyring");
const generateCrustAuthToken = (suri) => {
    const keyring = new keyring_1.Keyring();
    const pair = keyring.addFromUri(suri);
    // 1.3 get the signature of the addr
    const sigRaw = pair.sign(pair.address);
    const sig = (0, util_1.u8aToHex)(sigRaw);
    // 1.4 compile the sig to autHeader
    const authHeaderRaw = `sub-${pair.address}:${sig}`;
    return Buffer.from(authHeaderRaw).toString('base64');
};
exports.generateCrustAuthToken = generateCrustAuthToken;
